    import React, {useState} from 'react';
    import { timeSpentOnPatient } from '../../actions/HRActions';
    import { useDispatch } from 'react-redux';
    import moment from 'moment';
    import {Modal, Button, Form as BootstrapForm} from 'react-bootstrap';
    import {useAlert} from 'react-alert';
    import { uploadFileError, UPLOAD_ACCEPT } from '../../utils/uploadLimits';
    

    const AddTimeManually = ({hrId, patientId, patientType}) => {
        const alert = useAlert();
        let minutes;
    
        // Form Fields
        const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
        const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
        const [startTime, setStartTime] = useState(moment().tz("America/New_York").format("HH:mm"));
        const [endTime, setEndTime] = useState(moment().tz("America/New_York").add(4, 'minutes').format("HH:mm"));
        // no program default (owner decision 2026-09-26): staff must declare CCM | PCM | RPM | APCM per entry
        const [program, setProgram] = useState('');
        const PROGRAMS = ['CCM', 'PCM', 'RPM', 'APCM'];
        const [interactiveMinutes, setInteractiveMinutes] = useState(false);
        const [note, setNote] = useState('');
        const [fileName, setFileName] = useState({});
        const [fileError, setFileError] = useState('');
        const [confirmationModal, setConfirmationModal] = useState(false);

        const handleClose = () => setConfirmationModal(false);
        const handleShow = () => setConfirmationModal(true);    


        // Calculating time duration starts
        // var timeStart = moment(startTime, 'HH:mm:ss a');
        // var timeEnd = moment(endTime, 'HH:mm:ss a');
        // var duration = moment.duration(timeEnd.diff(timeStart));
        // minutes = parseInt(duration.asMinutes()) % 60;
        // Calculating time duration ends

        var timeStart = moment(startTime, 'HH:mm:ss a');
        var timeEnd = moment(endTime, 'HH:mm:ss a');
        var dif = moment.duration(timeEnd.diff(timeStart));
        minutes = (dif.hours() * 60) + dif.minutes();


        const dispatch = useDispatch();  

        const handleFileChange = e => {
            const file = e.target.files[0];
            const problem = uploadFileError(file);
            setFileError(problem || '');
            if (problem) {
                e.target.value = '';
                setFileName({});
                return;
            }
            setFileName(file || {});
        }

        const handleSubmit = (e) => {
            e.preventDefault();

            if (!program) {
                alert.error('Select the program (CCM, PCM, RPM or APCM) for this time entry');
                return;
            }
            if(startDate && endDate && startTime && endTime && note !== "" || undefined){
                handleShow(true);
            }
            // alert.error('Please fill out required fields');
            return
        }


        const submitTimeSpent = () => {
            
            const fileProblem = uploadFileError(fileName);
            if (fileProblem) {
                alert.error(fileProblem);
                return;
            }
            
            if(minutes > 0 && minutes <= 90){
                Promise.resolve(dispatch(timeSpentOnPatient(patientId, 
                    hrId,
                    startDate, 
                    endDate,
                    startTime,
                    endTime, 
                    program, 
                    interactiveMinutes,
                    minutes,
                    note,
                    fileName
                    ))).then((saved) => {
                        // warn-only enrollment grace: saved, but not billable until enrolled
                        if (saved?.enrollmentWarning?.message) alert.info(saved.enrollmentWarning.message, { timeout: 15000 });
                    });
                }       
            } 

    return (
        <>
            <div>   
                    <div>    
                        <BootstrapForm>
                        <small>
                            <p style={{textAlign: 'justify-content'}}></p><span style={{color: 'red', fontWeight: 'bold'}}>Note : </span> {patientType === 'RPM' ? 'As patient is enrolled in RPM only, therefore you can only add minutes in RPM category.' : 
                            patientType === 'CCM' ? 'As patient is enrolled in CCM only, therefore you can only add minutes in CCM category.' 
                            : 'As patient is enrolled in RPM & CCM therefore you can add minutes in both categories.' }
                        </small>
                                <br />
                            <div className="row">
                                <div className="col-md-6">
                                <label className="form-label mt-3">Start Date</label>
                                    <input type="date" 
                                        className="form-control"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                        max={moment().format("YYYY-MM-DD")}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                <label className="form-label mt-3">End Date</label>
                                    <input type="date" 
                                        className="form-control"
                                        defaultValue={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                        max={moment().format("YYYY-MM-DD")}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label mt-3">Start Time</label>
                                        <input type="time" 
                                            className="form-control"
                                            value={startTime}
                                            onChange={e => setStartTime(e.target.value)} 
                                            required
                                        />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label mt-3">End Time</label>
                                        <input type="time" 
                                            className="form-control" 
                                            value={endTime}
                                            onChange={e => setEndTime(e.target.value)} 
                                            required
                                        />
                                </div>

                                <br />
                                <p className="text-muted pl-3 pt-2">
                                    Calculated time duration is : <span style={{color: '#004aad', fontWeight: 'bold'}}>
                                        {minutes} minutes
                                        </span>
                                </p>
                                <br/><br/>
                                
                            
                                <div className="col-md-6">
                                    <label htmlFor="timeEntryProgram"><b>Program (required)</b></label>
                                    <select id="timeEntryProgram" className="form-control" value={program} required onChange={(e) => setProgram(e.target.value)}>
                                        <option value="">Select program</option>
                                        {PROGRAMS.map(p => <option key={p} value={p}>{p}</option>)}
                                    </select>
                                </div> 

                                <small className="text-muted ml-3">Every time entry must declare its program - there is no default. PCM minutes require an active PCM enrollment.</small>
                                <br />
                                
                                <div className="col-md-12">
                                    <label className="form-label mt-3">Conclusion</label>   
                                    <textarea 
                                        className="form-control" 
                                        rows="4" 
                                        placeholder="Enter conclusion here ..."
                                        value={note}
                                        onChange={e => setNote(e.target.value)}
                                        >
                                    </textarea>
                                </div>

                               <div className="col-md-12">
                                <br/>     
                                <span>
                                    <input 
                                        label="File" 
                                        name="fileName" 
                                        type="file" 
                                        accept={UPLOAD_ACCEPT}
                                        onChange={handleFileChange}
                                    />
                                    {fileError && <small className="text-danger d-block">{fileError}</small>}
                                </span>
                               </div>

                                </div>

                                <br />

                            <div className="row-class" style={{justifyContent: 'space-between'}}>
                                <button className="edit-pill" onClick={handleSubmit}>Add Minutes</button>
                            </div>
                            </BootstrapForm>
                        </div>
                
                    
                    {/* Modal to add interactive minutes */}
                    <Modal show={confirmationModal} onHide={handleClose}>
                        <Modal.Body>
                        <h5 style={{color: '#004aad'}}>
                            <i class='bx bx-bell'></i> <strong>&nbsp;Alert </strong>
                        </h5>
                        <br />

                        <div className="text-center">
                            <p> Are you sure you want to mark this patient as reviewed and adding <span style={{color: 'red', fontWeight: 'bold'}}>{minutes}</span> minutes ? </p>  
                            
                            <br />
                            <BootstrapForm.Check
                                inline
                                label="Mark as Interactive Minutes "
                                type='checkbox'
                                value={interactiveMinutes}
                                onChange={e => setInteractiveMinutes(e.target.checked)}
                                id='inline-checkbox-1'
                            /> 
                        </div>
                        </Modal.Body>

                        <Modal.Footer>
                        <button className="edit-pill" onClick={submitTimeSpent}>
                            Submit minutes
                        </button>
                        </Modal.Footer>
                    </Modal>
                </div>
                </>
            )
        }

        

    export default AddTimeManually